var map = {
	"./fortuneIcon.svg": 470,
	"./fortuneIconL.svg": 471,
	"./helpdeskIcon.svg": 472,
	"./helpdeskIconL.svg": 473,
	"./homeIcon.svg": 474,
	"./homeIconLarge.svg": 475,
	"./jackpotIcon.svg": 476,
	"./logo.svg": 477,
	"./logoSmall.svg": 478,
	"./loyaltyIcon.svg": 479,
	"./mobileAppIcon.svg": 480,
	"./profileIcon.svg": 481,
	"./questIcon.svg": 482,
	"./rewardLineupIcon.svg": 483,
	"./searchIcon.svg": 484,
	"./searchIconLarge.svg": 485,
	"./signOutIcon.svg": 486,
	"./star.svg": 487,
	"./tournamentIcon.svg": 488,
	"./tournamentLargeIcon.svg": 489,
	"./vipIcon.svg": 490,
	"./wheelIcon.svg": 491,
	"./wheelIconL.svg": 492,
	"./wheelIconMobile.svg": 493
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 805;